var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { generateReducer, } from "../generators/generator.reducer";
import { getPreferencesStart, getPreferenceSucceeded, getPreferenceFailed, createPreferenceStart, createPreferenceSucceeded, createPreferenceFailed, updatePreferenceStart, updatePreferenceSucceeded, updatePreferenceFailed, } from "./preference.actions";
import { GENERATOR_PARAMS } from "./preference.constants";
var getExtraDefaultState = function () { return ({
    preferences: {},
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(getPreferencesStart.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), { isFetching: true, fetchError: undefined }) });
});
reducer.on(getPreferenceSucceeded.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: {
            items: payload.data,
            isFetching: false,
            fetchError: undefined,
        } });
});
reducer.on(getPreferenceFailed.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), { isFetching: false, fetchError: payload.error }) });
});
reducer.on(createPreferenceStart.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), { isCreating: true, createError: undefined }) });
});
reducer.on(createPreferenceSucceeded.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: {
            items: payload.data,
            isCreating: false,
            createError: undefined,
        } });
});
reducer.on(createPreferenceFailed.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), { isCreating: false, createError: payload.error }) });
});
reducer.on(updatePreferenceStart.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), { isUpdating: true, updateError: undefined }) });
});
reducer.on(updatePreferenceSucceeded.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: {
            items: payload.data,
            isUpdating: false,
            updateError: undefined,
        } });
});
reducer.on(updatePreferenceFailed.type, function (state, payload) {
    return __assign(__assign({}, state), { preferences: __assign(__assign({}, state.preferences), { isUpdating: false, updateError: payload.error }) });
});
// eslint-disable-next-line import/no-default-export
export default reducer;
